export const userInfo = state => {
    return state.userInfo
}
export const token = state => state.token
export const hasLogin = state => state.hasLogin